import React, { Suspense } from "react";

/**
 * Wraps component with suspense component.
 * @param Component
 */
export function withSuspense<T>(
	Component: React.FC<T>,
	fallback: React.ReactNode = <div>Lädt...</div>,
) {
	const SuspendedComponent = (props: T) => (
		<Suspense fallback={fallback}>
			{/* @ts-expect-error */}
			<Component {...props} />
		</Suspense>
	);
	SuspendedComponent.displayName = `Suspense(${Component.displayName})`;
	return SuspendedComponent;
}
